import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { FiscalYearMinister, Payload } from './fiscalYearMinister.model';
import fiscalYearMinisterService from './fiscalYearMinister.service';

// namespace
export const FISCALYEAR_MINISTER_STORE_NAMESPACE = 'fiscalYearMinisterStore';

// state
interface FiscalYearMinisterState {
  fiscalYearMinisters: FiscalYearMinister[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: FiscalYearMinisterState = {
  fiscalYearMinisters: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<FiscalYearMinisterState> = {
  [mutationConstant.FETCH]: (state: FiscalYearMinisterState, fiscalYearMinisters: FiscalYearMinister[]) => {
    state.fiscalYearMinisters = fiscalYearMinisters;
  },
  [mutationConstant.PENDING]: (state: FiscalYearMinisterState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: FiscalYearMinisterState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: FiscalYearMinisterState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch'
};

const action: ActionTree<FiscalYearMinisterState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<FiscalYearMinisterState, RootState>, payload: Payload) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      fiscalYearMinisterService.Fetch(payload.fiscalYearId)
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  }
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<FiscalYearMinisterState, RootState> = {
  [getterConstant.ALL]: (state: FiscalYearMinisterState) => state.fiscalYearMinisters,
  [getterConstant.BY_ID]: (state: FiscalYearMinisterState) => (id: number) => state.fiscalYearMinisters.find(m => m.id === id),
  [getterConstant.STATUS]: (state: FiscalYearMinisterState) => state.status,
};

// module
const module: Module<FiscalYearMinisterState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const FiscalYearMinisterGetter = {
  ALL: `${FISCALYEAR_MINISTER_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_ID: `${FISCALYEAR_MINISTER_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${FISCALYEAR_MINISTER_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const FiscalYearMinisterAction = {
  FETCH: `${FISCALYEAR_MINISTER_STORE_NAMESPACE}/${actionConstant.FETCH}`
};

export default module;
